import React from "react";
import { useTranslation } from "react-i18next";

import { getCurrentCulture } from "@utils";

import { ReactLazyImportWithGuard as lazy } from "@lib/lazy-import-with-guard";

const loadFailPath = `/${getCurrentCulture()}/app-update`;

// prettier-ignore
const ReactMarkdown = lazy(loadFailPath, () => import("react-markdown"));

export default function HeaderWelcome() {
	const { t } = useTranslation("specific");

	return (
		<ReactMarkdown className="header__top__caption header__top__markdown">
			{t("COMMON.SLIDER.WELCOME")}
		</ReactMarkdown>
	);
}
